export default __webpack_public_path__ + "6b165eed1e95a080b0e4f9418100d9f1.svg";